import { Column, Grid, Row } from "@1js/pl-card-components";
import * as React from "react";
import { SectionTitle } from "../SectionTitle/SectionTitle.web";

import type { Article } from "../data";
import { ArticleList } from "./ArticleList.web";

export const ArticleListSection: React.FC<{
  title: string;
  id: string;
  articles: Article[];
}> = ({ title, articles, id }) => {
  return (
    <Grid testid={id}>
      <Row>
        <Column size={12}>
          <SectionTitle title={title} />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <ArticleList id={id} articles={articles} />
        </Column>
      </Row>
    </Grid>
  );
};
